
import { useEffect, useRef } from 'react'


import "./scrolltext.css"

export const ScrollText = ({placeholdertext, text, disabled, rows, onChange}) => {


  const textAreaRef = useRef(null);

  useEffect(() => {
    
    if (textAreaRef.current) {
      textAreaRef.current.style.height = 'auto';
      textAreaRef.current.style.height = `${textAreaRef.current.scrollHeight}px`;
    }
    
  }, [text, textAreaRef]);
  
  return (
    <textarea className="scrollText"
               id = 'myTextarea'
               ref = {textAreaRef} 
            
                placeholder={placeholdertext}
                value={text}
                disabled={disabled}
                onChange={event => onChange(event)}
                rows={rows}
                wrap="soft"
              />
  );

 
};

ScrollText.defaultProps = {
  disabled: false,
  placeholdertext: '',
  rows: 3,
}
